import React, { Component } from 'react';
import { connect } from 'react-redux';
import { bindActionCreators } from 'redux';
import Form, { Heading } from '../Form';
import Loader from '../Loader';
import Button from '../Button';
import Row from '../Row';
import Col from '../Col';
import Input from '../Input';
import Picker from '../Picker';
import Select from '../Select';
import moment from 'moment';
import { selectItems,selectItemsForAssets } from '../../store/selectors/items';
import { setCommonAreaAssetFormData,clearCommonAreaAssetFormData } from '../../store/actions/commonAreaAssetForm';
import { selectCommonAreaAssetFormData } from '../../store/selectors/commonAreaAssetForm';
import { selectContacts } from '../../store/selectors/contacts';
import { selectValidation } from '../../store/selectors/Validation';
import { selectFormLoader } from '../../store/selectors/FormLoader';
import { clearValidation } from '../../store/actions/validation';
import { variables } from '../../Tenants';

class CommonAreaAssetForm extends Component {
    state = {
        formData: {
          item_id: '',
          serial_number: '',
          room: '',
          dateOfPurchase: null
        },
        buttonPressed: '',
        display: false,
        vendorSearch: '',
        displayItem: false,
        itemSearch: '',
        isChanged: false
    };

    componentWillMount () {
        const { commonAreaId, commonAreaAssetFormData, clearValidation} = this.props;
        
        clearValidation()
    }

    componentDidUpdate(prevProps) {
        const { setCommonAreaAssetFormData, commonAreaAssetFormData, validation, onClose, clearValidation, clearCommonAreaAssetFormData } = this.props;
        let assetWarrantyDefaultStartDate = commonAreaAssetFormData.assetWarrantyDefaultStartDate;
        if (validation.status === true) {
            if (validation.message === 'This serial number already exists, please try another.') {
                clearValidation();
            } else if (validation.message === 'Success' && this.state.buttonPressed === 'SaveAndClose') {
                onClose();
                clearCommonAreaAssetFormData();
                clearValidation();
            } else if (validation.message === 'Success' && this.state.buttonPressed === 'SaveAndAdd') {
                clearCommonAreaAssetFormData();
                setCommonAreaAssetFormData({
                    assetWarrantyDefaultStartDate: assetWarrantyDefaultStartDate,
                    dateOfPurchase: assetWarrantyDefaultStartDate
                })
                clearValidation();
            }
        }
      }
    
    
      onChange = (object) => {
        const { commonAreaAssetFormData,setCommonAreaAssetFormData } = this.props;
        let data = {}
          for (var i = 0; i < this.props.items.length; i++) {
            if (this.props.items[i].id === object.value) {
              data.item = { name: this.props.items[i].name, make: this.props.items[i].makeName, model: this.props.items[i].model }
            }
          }
          data.itemId = object.value;
          
          setCommonAreaAssetFormData({
            ...commonAreaAssetFormData,
            ...data
          })
          setCommonAreaAssetFormData({
            itemName: object.label
          })
          this.setState({ displayItem: false, itemSearch: '', isChanged: false})
      }
    
      onSaveCommonAreaAsset(fndData){
        const { onClose, onSaveCommonAreaAsset, clearCommonAreaAssetFormData } = this.props;
        onSaveCommonAreaAsset(fndData);
        if(this.state.buttonPressed === 'SaveAndAdd') {
          clearCommonAreaAssetFormData();
        } else {
         onClose();
        }
      }
    
      handleSelectedValue(e){
        const { suiteAssetAreas,setAssetFormData } = this.props;
        let selectedData = suiteAssetAreas.filter( room => room.areaId === e.target.value)[0]
        setAssetFormData({ roomType: selectedData && selectedData.customLabel ? selectedData.customLabel : selectedData.name,areaId: selectedData.areaId})
    
      }

    render(){
        const { newAsset, onClose, commonAreaAssetFormData, setCommonAreaAssetFormData,itemDropDown,contacts } = this.props;
        let vendorContacts = contacts.filter(item => item.roles && item.roles.length > 0 ? item.roles[0].role.name === 'Vendor' : []);
        let condition;
        if (commonAreaAssetFormData && commonAreaAssetFormData.assetWarrantyDefaultStartDate && commonAreaAssetFormData && commonAreaAssetFormData.dateOfPurchase) {
            if (moment(commonAreaAssetFormData.assetWarrantyDefaultStartDate).format('MM-DD-YYYY') === moment(commonAreaAssetFormData.dateOfPurchase).format('MM-DD-YYYY')) {
                condition = true
            } else {
                condition = false
            }
        }
        return(
            <Form 
                headline={ newAsset ? "Add a Common Area Asset" : "Edit a Common Area Asset" }
                onClose={ onClose }
                onSubmit={ ()=> this.onSaveCommonAreaAsset( commonAreaAssetFormData )}
                actions={(
                    <>
                        {/* { loader ? <Loader center={true} /> : null } */}
                        {
                            newAsset ? <Button 
                                color="semantic"
                                size="small"
                                label="Save and Add Another"
                                onClick={ () => this.setState({ buttonPressed:'SaveAndAdd'}) }
                                disabled={ (commonAreaAssetFormData.item && commonAreaAssetFormData.item.id ? !commonAreaAssetFormData.item.id : !commonAreaAssetFormData.itemId) || !commonAreaAssetFormData.dateOfPurchase}
                            /> 
                            :
                            <div />
                        }
                        <Button
                            color="teal"
                            size="small"
                            label="Save Common Area Asset"
                            onClick={() => this.setState({
                                buttonPressed: 'SaveAndClose'
                            })}
                            disabled={ (commonAreaAssetFormData.item && commonAreaAssetFormData.item.id ? !commonAreaAssetFormData.item.id : !commonAreaAssetFormData.itemId) || !commonAreaAssetFormData.dateOfPurchase}
                        />
                    </>
                )}
                component={(
                    <>
                        <Row mdCenter>
                            <Col
                                xs="12"
                                md="6"
                            >
                                <Heading>Common Area Asset Details</Heading>
                                <Input
                                    value={this.state.isChanged ? commonAreaAssetFormData.itemName : commonAreaAssetFormData.item && commonAreaAssetFormData.item.id ? commonAreaAssetFormData.item.name : commonAreaAssetFormData.itemId ? commonAreaAssetFormData.itemName : commonAreaAssetFormData.itemName}
                                    onChange={e => { setCommonAreaAssetFormData({ itemName: e.target.value }); this.setState({ displayItem: true, isChanged: true, itemSearch: e.target.value }) }}
                                    label="Item"
                                    placeholder="Start typing the Item's name to choose one"
                                    block
                                />
                                <Col>
                                    {this.state.itemSearch ? itemDropDown
                                        .filter(({ label }) => label.toLowerCase().indexOf(this.state.itemSearch.toLowerCase()) > -1)
                                        .map((value, i) => {
                                            return (
                                                <div
                                                    onClick={() => this.onChange(value)}
                                                    className="input__autoComplete"
                                                    key={i}
                                                >
                                                    <span>{value.label}</span>
                                                </div>
                                            );
                                        }) : null}
                                </Col>
                                {
                                    condition ?
                                        <div style={{ alignItems: 'flex-start', display: 'flex', marginBottom: 10, color: '#D3D3D3' }}>
                                           {`Default date is set at the ${variables.suite} level`}.
                                        </div>
                                        : 
                                        null
                                }
                                <Picker
                                    label="Warranty Commencement Date"
                                    placeholderText="Choose Date"
                                    required={true}
                                    showPopperArrow={false}
                                    selected={commonAreaAssetFormData && commonAreaAssetFormData.dateOfPurchase ? new Date(commonAreaAssetFormData.dateOfPurchase) : null}
                                    onChange={(date) => setCommonAreaAssetFormData({ dateOfPurchase: date })}
                                />
                                
                                {/* <Input
                                    value={commonAreaAssetFormData.vendorName ? commonAreaAssetFormData.vendorName : this.state.vendorSearch}
                                    onChange={e => { setCommonAreaAssetFormData({ vendorName: e.target.value, vendorId: null }); this.setState({ display: true, vendorSearch: e.target.value }) }}
                                    label="Vendor"
                                    placeholder="Start typing the Vendor's name to choose one"
                                    block
                                />
                                <Col>
                                    {
                                        this.state.vendorSearch ? vendorContacts
                                        .filter(({ firstname, lastname }) => firstname.toLowerCase().indexOf(this.state.vendorSearch.toLowerCase()) > -1 || lastname.toLowerCase().indexOf(this.state.vendorSearch.toLowerCase()) > -1)
                                        .map((value, i) => {
                                            return (
                                                <div
                                                    onClick={() => { setCommonAreaAssetFormData({ vendorId: value.id, vendorName: value.firstname + ' ' + value.lastname }); this.setState({ display: false, vendorSearch: '' }) }}
                                                    className="input__autoComplete"
                                                    key={i}
                                                >
                                                    <span>{value.firstname + ' ' + value.lastname}</span>
                                                </div>
                                            );
                                        })
                                         :
                                        null
                                    }
                                </Col> */}
                                
                            </Col>
                        </Row>
                    </>
                )}
            />
        )
    }
}

const mapStateToProps = ( state, ownProps ) => ({
    items:selectItems(state),
    itemDropDown:selectItemsForAssets(state),
    commonAreaAssetFormData:selectCommonAreaAssetFormData(state),
    contacts:selectContacts(state),
    validation:selectValidation(state),
    loader:selectFormLoader(state)
})

const mapDispatchToProps = dispatch => bindActionCreators({
    setCommonAreaAssetFormData,
    clearCommonAreaAssetFormData,
    clearValidation

},dispatch)

export default connect(mapStateToProps, mapDispatchToProps)(CommonAreaAssetForm);